import { render, staticRenderFns } from "./IssuesList.vue?vue&type=template&id=c3c46a30&scoped=true"
import script from "./IssuesList.vue?vue&type=script&lang=js"
export * from "./IssuesList.vue?vue&type=script&lang=js"
import style0 from "./IssuesList.vue?vue&type=style&index=0&id=c3c46a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c46a30",
  null
  
)

export default component.exports